import { format } from 'date-fns';

export const CLIENT_DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_FORMAT_TO_DB = 'yyyy-MM-dd H:mm:ss.SSSS';

/** Пустая / epoch / невалидная дата публикации → не показывать на сайте. */
export function formatClientPublishDate(value) {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime()) || date.getTime() <= 0) {
    return '';
  }

  return format(date, CLIENT_DATE_FORMAT);
}

/** Диапазон дат; без даты снятия — только дата публикации (без «… - 01.01.1970»). */
export function formatClientDateRange(start, end) {
  const from = formatClientPublishDate(start);
  const to = formatClientPublishDate(end);
  if (from && to) {
    return `${from} - ${to}`;
  }
  return from || to || '';
}
